"use client";

import { ReactNode } from "react";

import { MyWatchList } from "@/layouts/my-watch-list";

export const MyContent = ({ children }: { children: ReactNode }) => {
  return (
    <div className="relative flex">
      <main className="flex-1 @container">{children}</main>
      <MyWatchList />
    </div>
  );
};
